<template>
    <div class="lg:w-[630px] lg_tall:w-[550px] h-[120px] flex flex-col items-center justify-center rounded-2xl border-main-0 border-[1px]
        sm:h-[100px] sm:flex sm:flex-col sm:items-center sm:justify-center sm:rounded-lg">
        <p class="font-semibold text-content-size sm:font-semibold text-main-1">{{ title }}</p>
        <p class="text-small-size sm:text-small-size-1 sm:mx-4 sm:font-medium sm:text-center mt-3 text-gray_1" v-html="description"></p>
    </div>
</template>
<script>
export default {
    props: ['title', 'description'],
    data() {
        return {

        }
    }
}
</script>
